import React from "react";
import { QRCodeSVG } from "qrcode.react";

export default function QRCodeModal({ url, playerName, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl w-full max-w-xs p-8 text-center shadow-xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-black/30 hover:text-black"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <p className="font-display text-lg font-bold text-black mb-4">
          Scan to Donate
        </p>
        <div className="inline-block p-4 bg-white border-2 border-black rounded-xl mb-4">
          <QRCodeSVG
            value={url}
            size={180}
            level="M"
            fgColor="#111111"
          />
        </div>
        <p className="text-sm text-black/50">
          Donate for {playerName}
        </p>
      </div>
    </div>
  );
}
